export default __webpack_public_path__ + "static/media/background.f9734dbf.png";